import { create } from 'zustand';

/**
 * Toast 状态管理
 * 使用 Zustand 管理全局 Toast 状态
 */
const useToastStore = create((set) => ({
  toasts: [],
  
  // 添加 Toast
  addToast: (toast) => {
    const id = toast.id || `toast-${Date.now()}-${Math.random()}`;
    const newToast = {
      id,
      message: toast.message || '操作成功',
      type: toast.type || 'info',
      duration: toast.duration !== undefined ? toast.duration : 3000,
    };
    
    set((state) => ({
      toasts: [...state.toasts, newToast],
    }));
    
    return id;
  },
  
  // 移除 Toast
  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },
  
  // 清除所有 Toast
  clearToasts: () => {
    set({ toasts: [] });
  },
}));

/**
 * Toast Hook
 * 提供便捷的 Toast 操作方法
 */
export const useToast = () => {
  const { toasts, addToast, removeToast, clearToasts } = useToastStore();
  
  return {
    toasts,
    removeToast,
    clearToasts,
    
    // 成功提醒
    success: (message, duration) => {
      return addToast({ message, type: 'success', duration });
    },
    
    // 错误提醒
    error: (message, duration) => {
      return addToast({ message, type: 'error', duration });
    },
    
    // 警告提醒
    warning: (message, duration) => {
      return addToast({ message, type: 'warning', duration });
    },
    
    // 信息提醒
    info: (message, duration) => {
      return addToast({ message, type: 'info', duration });
    },
    
    // 自定义 Toast
    show: (options) => {
      return addToast(options);
    },
  };
};

export default useToast;
